export default __webpack_public_path__ + "static/media/pointofsale.aae71d23.svg";